import { Grid, Paper } from '@material-ui/core';
import React from 'react';

import {
  dashboardCompareKeyAudibleViewableCustomQ2,
  dashboardCompareKeyAudibleViewableIndStdQ4,
  dashboardCompareKeyAVOCGroupMRate,
  dashboardCompareKeyAVOCRate,
  dashboardCompareKeyBlockedAds,
  dashboardCompareKeyBlockedImps,
  dashboardCompareKeyBlockedRate,
  dashboardCompareKeyEligibleAds,
  dashboardCompareKeyImpressionsRendered,
  dashboardCompareKeyInvalidTrafficAds,
  dashboardCompareKeyInvalidTrafficRate,
  dashboardCompareKeyMeasuredAds,
  dashboardCompareKeyMeasuredRate,
  dashboardCompareKeyPassedAds,
  dashboardCompareKeyRenderRate,
  dashboardCompareKeySuspiciousImps,
  dashboardCompareKeyTrackedAds,
  dashboardCompareKeyUnsuspiciousImps,
  dashboardCompareKeyUnviewableImps,
  dashboardCompareKeyViewableImpressions,
  dashboardCompareKeyViewableRate,
  dashboardKeyAudibleViewableCustomQ2,
  dashboardKeyAudibleViewableIndStdQ4,
  dashboardKeyAVOCGroupMRate,
  dashboardKeyAVOCRate,
  dashboardKeyBlockedAds,
  dashboardKeyBlockedImps,
  dashboardKeyBlockedRate,
  dashboardKeyEligibleAds,
  dashboardKeyImpressionsRendered,
  dashboardKeyInvalidTrafficAds,
  dashboardKeyInvalidTrafficRate,
  dashboardKeyMeasuredAds,
  dashboardKeyMeasuredRate,
  dashboardKeyPassedAds,
  dashboardKeyRenderRate,
  dashboardKeysToTitlesMapping,
  dashboardKeySuspiciousImps,
  dashboardKeyTrackedAds,
  dashboardKeyUnsuspiciousImps,
  dashboardKeyUnviewableImps,
  dashboardKeyViewableImpressions,
  dashboardKeyViewableRate,
} from '~/src/dash/api/ias-wrapper-api/constants';
import { IDataItem, MakeDashes, MakeDot } from '~/src/dash/components/dashboard/dashboard-graph';
import { DashboardCardDataCompareKeys, DashboardCardDataKeys } from '~/src/dash/globals/constants';
import { DateGroup } from '~/src/dash/utils/date';
import { FirstAndThirdPartyDashboardCardDataTitles } from '~/src/dash/views/measurement-home-view';
import {
  networkHomeAggDataComparisonKeys,
  networkHomeAggDataKeys,
  networkHomeKeysToTitlesMapping,
  networkHomeLiveDataKeys,
  StreamDashboardCardDataTitles,
} from '~/src/dash/views/networks/constants';

interface ICustomTooltipPayloadItem {
  color: string;
  dataKey: DashboardCardDataKeys | DashboardCardDataCompareKeys;
  value: any;
  payload: IDataItem;
}

interface ITooltipLabel {
  valueString: string;
  dataKeyString: string;
}

interface IProps {
  active?: boolean;
  payload?: ICustomTooltipPayloadItem[];
  loaded: boolean;
  width?: number;
  densityRange?: DateGroup;
  currencySymbol: string;
}

export const DashboardTooltipV2 = (props: IProps) => {
  const { active, loaded } = props;
  const payload = props.payload;

  if (active && loaded && Array.isArray(payload)) {
    return (
      <Paper
        className='custom-tooltip'
        style={{
          backgroundColor: '#f3f3f3',
          padding: 10,
          width: props.width || 300,
        }}
      >
        {(payload || []).map((datum: ICustomTooltipPayloadItem) => {
          const { color, dataKey, value, payload } = datum;
          const hidden = false;
          const opacity = 1;
          const keysToTitleMapping = {
            ...dashboardKeysToTitlesMapping,
            ...networkHomeKeysToTitlesMapping,
          };
          const LATENCY_DATA_KEYS = new Set<string>([
            networkHomeAggDataKeys.AGG_AVG_STREAM_AD_FILLED_LATENCY_KEY,
            networkHomeAggDataComparisonKeys.AGG_AVG_STREAM_AD_FILLED_LATENCY_COMPARE_KEY,
            networkHomeLiveDataKeys.STREAM_AD_FILLED_LATENCY_KEY,
          ]);
          const PERCENTAGE_DATA_KEYS = new Set<string>([
            dashboardKeyRenderRate,
            dashboardCompareKeyRenderRate,
            dashboardKeyInvalidTrafficRate,
            dashboardCompareKeyInvalidTrafficRate,
            dashboardKeyMeasuredRate,
            dashboardCompareKeyMeasuredRate,
            dashboardKeyViewableRate,
            dashboardCompareKeyViewableRate,
            dashboardKeyBlockedRate,
            dashboardCompareKeyBlockedRate,
            dashboardKeyAVOCGroupMRate,
            dashboardCompareKeyAVOCGroupMRate,
            dashboardKeyAVOCRate,
            dashboardCompareKeyAVOCRate,
          ]);
          const DIMENSIONLESS_DATA_KEYS = new Set<string>([
            networkHomeAggDataKeys.AGG_AD_IMPRESSIONS_KEY,
            networkHomeAggDataComparisonKeys.AGG_AD_IMPRESSIONS_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_ADS_FETCH_TIMEOUT_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_ADS_FETCH_TIMEOUT_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_ADS_FILLED_KEY,
            networkHomeAggDataComparisonKeys.AGG_ADS_FILLED_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_PODS_FILLED_KEY,
            networkHomeAggDataComparisonKeys.AGG_PODS_FILLED_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_ERROR_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_ERROR_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_PLAYLIST_TIMEOUT_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_PLAYLIST_TIMEOUT_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_POD_REQUESTS_KEY,
            networkHomeAggDataComparisonKeys.AGG_POD_REQUESTS_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_CHUNKLIST_FETCH_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_CHUNKLIST_FETCH_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_START_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_START_COMPARE_KEY,
            networkHomeAggDataKeys.AGG_STREAM_CHUNKLIST_RESPONSE_KEY,
            networkHomeAggDataComparisonKeys.AGG_STREAM_CHUNKLIST_RESPONSE_COMPARE_KEY,
            networkHomeLiveDataKeys.STREAM_AD_COMPLETE_KEY,
            networkHomeLiveDataKeys.STREAM_AD_FILLED_KEY,
            networkHomeLiveDataKeys.STREAM_POD_REQUEST_KEY,
            networkHomeLiveDataKeys.STREAM_POD_FILLED_KEY,
            networkHomeLiveDataKeys.STREAM_AD_IMPRESSION_KEY,
            networkHomeLiveDataKeys.STREAM_CHUNKLIST_RESPONSE_KEY,
            networkHomeLiveDataKeys.STREAM_AD_FETCH_TIMEOUT_KEY,
            networkHomeLiveDataKeys.STREAM_CHUNKLIST_TIMEOUT_KEY,
            networkHomeLiveDataKeys.STREAM_TRANSCODE_MISS_KEY,
            networkHomeLiveDataKeys.STREAM_TRANSCODE_MISS_ERROR_KEY,
            networkHomeLiveDataKeys.STREAM_CACHED_AD_MISS_KEY,
            networkHomeLiveDataKeys.STREAM_ADS_FETCH_ERROR_KEY,
            networkHomeLiveDataKeys.STREAM_PLAYLIST_ERROR_KEY,
            networkHomeLiveDataKeys.STREAM_CHUNKLIST_ERROR_KEY,
            networkHomeLiveDataKeys.STREAM_CACHE_READ_MISS_ERROR_KEY,
            dashboardKeyTrackedAds,
            dashboardCompareKeyTrackedAds,
            dashboardKeyImpressionsRendered,
            dashboardCompareKeyImpressionsRendered,
            dashboardKeyInvalidTrafficAds,
            dashboardCompareKeyInvalidTrafficAds,
            dashboardKeyEligibleAds,
            dashboardCompareKeyEligibleAds,
            dashboardKeyMeasuredAds,
            dashboardCompareKeyMeasuredAds,
            dashboardKeyViewableImpressions,
            dashboardCompareKeyViewableImpressions,
            dashboardKeyBlockedAds,
            dashboardCompareKeyBlockedAds,
            dashboardKeySuspiciousImps,
            dashboardCompareKeySuspiciousImps,
            dashboardKeyUnsuspiciousImps,
            dashboardCompareKeyUnsuspiciousImps,
            dashboardKeyUnviewableImps,
            dashboardCompareKeyUnviewableImps,
            dashboardKeyBlockedImps,
            dashboardCompareKeyBlockedImps,
            dashboardKeyPassedAds,
            dashboardCompareKeyPassedAds,
            dashboardKeyAudibleViewableCustomQ2,
            dashboardCompareKeyAudibleViewableCustomQ2,
            dashboardKeyAudibleViewableIndStdQ4,
            dashboardCompareKeyAudibleViewableIndStdQ4,
          ]);

          const getTitleAndDisplayedNumber = (
            dataKey: any,
            value: any,
            titleFromKey: Record<
              string,
              FirstAndThirdPartyDashboardCardDataTitles | StreamDashboardCardDataTitles
            >,
            latencyKeys: Set<string>,
            percentageKeys: Set<string>,
            dimensionlessKeys: Set<string>,
          ): ITooltipLabel => {
            const toLatencyTooltipInEnglish = (value: any) => {
              return (
                value.toLocaleString('en', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
                'ms'
              );
            };
            const toPercentageTooltipInEnglish = (value: any) => {
              return (
                value.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
                '%'
              );
            };
            const toDimensionlessTooltipInEnglish = (value: any) => {
              return value.toLocaleString('en', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
            };
            const tooltipLabelValueAndTitle = {
              valueString: '',
              dataKeyString: titleFromKey[dataKey],
            };
            if (latencyKeys.has(dataKey)) {
              tooltipLabelValueAndTitle.valueString = toLatencyTooltipInEnglish(value);
            } else if (percentageKeys.has(dataKey)) {
              tooltipLabelValueAndTitle.valueString = toPercentageTooltipInEnglish(value);
            } else if (dimensionlessKeys.has(dataKey)) {
              tooltipLabelValueAndTitle.valueString = toDimensionlessTooltipInEnglish(value);
            }
            return tooltipLabelValueAndTitle;
          };

          // for each item, create a date, data and value string to display on the tool tip
          const { valueString, dataKeyString } = getTitleAndDisplayedNumber(
            dataKey,
            value,
            keysToTitleMapping,
            LATENCY_DATA_KEYS,
            PERCENTAGE_DATA_KEYS,
            DIMENSIONLESS_DATA_KEYS,
          );
          const dateString = dataKey.indexOf('Compare') > -1 ? payload.CDate : payload.Date;
          if (hidden) {
            return <React.Fragment />;
          }
          const isCompare = dataKey.indexOf('Compare') > -1;
          return (
            <Grid>
              {!isCompare && (
                <Grid
                  style={{
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  {dataKeyString}
                </Grid>
              )}
              <Grid container alignItems='center' spacing={1} key={dataKey}>
                {isCompare ? MakeDashes(color, opacity) : MakeDot(color, opacity)}
                <Grid
                  item
                  xs={4}
                  style={{
                    fontWeight: 500,
                    fontSize: 12,
                  }}
                >
                  {valueString}
                </Grid>
                <Grid
                  item
                  xs={6}
                  alignItems='flex-end'
                  style={{
                    fontSize: 12,
                  }}
                >
                  {dateString}
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Paper>
    );
  } else {
    return null;
  }
};
